import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
const requiredFieldMsg = "RequiredFieldErrMsg";
export const CancelOrderSchema = (isMultiPolicy) => {
  return yupResolver(
    Yup.object({
      cancelWholeOrder: isMultiPolicy
        ? Yup.string().required(requiredFieldMsg)
        : Yup.string(),
      policies: isMultiPolicy
        ? Yup.array().test("policiesTest", requiredFieldMsg, (val, context) => {
            if (context?.parent?.cancelWholeOrder === "No") {
              if (!val || val?.length === 0) {
                return false;
              }
            }
            return true;
          })
        : Yup.array(),
      reason: Yup.string().notOneOf(["0"], requiredFieldMsg).required(),
      reasonOther: Yup.string()
        .default("")
        .test("reasonOtherTest", requiredFieldMsg, (val, context) => {
          if (context?.parent?.reason === "Other") {
            if (!val || val === "") {
              return false;
            } else if (
              val.trim().toLocaleLowerCase() === "N/A" ||
              val.trim().toLocaleLowerCase() === "unknown" ||
              val?.length < 20
            ) {
              return false;
            }
          }
          return true;
        }),
    })
  );
};
